import React from 'react';
import madhankumarImg from '../assets/madhan.jfif'; // Import the image file
import gmail from '../assets/icons8-gmail-48.png'; // Import the image file
import SampleTemplate from '../assets/pdfs/Madhan Kumar Mamidala Profile.pdf';
import Microsoft from '../assets/microsoft.png'; // Import the image file


const Sidebar = () => {

    return (
        <div>
            <div className="card profilecard mt-3">
                <div>
                    <img className="bostami-parsonal-info-img shadow-lg img-fluid" src={madhankumarImg} alt="Madhan Kumar"/>
                </div>
                <h4 className="mt-3">
                    <a className="bostami-parsonal-info-name" href="#">Madhan Kumar Mamidala</a>
                </h4>
                <span className="bostami-parsonal-info-bio mb-15"><img src={Microsoft} className="img-fluid"style={{height:'20px',marginRight:'10px'}}/>Technical Lead</span>
                <div className=" text-center mt-3 mb-3">
                    <div class="list-social">
                            <a href="https://www.linkedin.com/in/madhankumarmamidala/" target="_blank"className="linkedin">
                                <i className="fa fa-linkedin"></i>
                            </a>
                        </div>
                       {/*<li class="list-social">
                            <a href="#" target="_blank"className="facebook">
                                <i className="fa fa-facebook"></i>
                            </a>
                        </li>
                        <li class="list-social">
                            <a href="#"target="_blank" className="twitter" style={{textDecoration:'none',fontWeight:'bold',fontSize:'24px',color:'#000'}}>
                               x
                            </a>
                        </li>
                       
                        
                        <li class="list-social">
                            <a href="#" target="_blank"className="instagram">
                                <i className="fa fa-instagram"></i>
                            </a>
                        </li>*/}
                </div>
                <div className="bostami-parsonal-info-contact mb-30">
                    <div className="bostami-parsonal-info-contact-item phone">
                        <div className="icon">
                            <i className="fa fa-mobile"></i>
                        </div>
                        <div className="text">
                            <span><b>Phone</b></span>
                            <p>+1(425) 540-7889</p>
                        </div>
                    </div>
                    <hr/>
                    <div className="bostami-parsonal-info-contact-item email">
                        <div className="icon">
                            <img src={gmail} style={{height:'15px',width:'15px'}}/>
                        </div>
                        <div className="text">
                            <span><b>Email</b></span>
                            <p>mamidalamadhan</p>
                        </div>
                    </div>
                    <hr/>
                    <div className="bostami-parsonal-info-contact-item location">
                        <div className="icon">
                            <i className="fa fa-map-marker"></i>
                        </div>
                        <div className="text">
                            <span><b>Location</b></span>
                            <p>Redmond, Washington</p>
                        </div>
                    </div>
                    <hr/>
                    <div className="bostami-parsonal-info-contact-item calendar">
                        <div className="icon">
                            <i className="fa fa-calendar"></i>
                        </div>
                        <div className="text">
                            <span><b>Birthday</b></span>
                            <p>July 17</p>
                        </div>
                    </div>
                </div>
                <div className="bostami-parsonal-info-btn">
                <a class="btn-1" href={SampleTemplate} download="Madhan Kumar Mamidala Profile.pdf">
                        <span className="icon">
                            <i className="fa fa-download"></i>
                        </span>
                        Profile
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
